






















import {Component, Prop, Mixins, Ref, Watch} from 'vue-property-decorator';
    import {Mixin} from "@/mixins";
    import styleSelect from "styleselect";

    @Component({
        name: "NiceSelect",
    })
    export default class NiceSelect extends Mixins(Mixin) {
        @Prop()
        value!: string|number;

        @Prop({
            default: ""
        })
        name!: string;

        @Prop()
        options!: { [key: string]: string };

        @Prop({
            default: false
        })
        sort!: boolean;

        @Prop({default: false})
        private readonly readonly!: boolean;

        @Ref('select')
        select?: HTMLSelectElement;

        get keys() {
            let ret = Object.keys(this.options);
            if (this.sort) {
                ret = ret.sort();
            }
            return ret;
        }

        get styleSelectUsed() {
            return !navigator.userAgent.match(/iPad|iPhone|Android/i);
        }

        @Watch('readonly')
        private onReadonlyChanged(): void {
            if (!this.readonly) {
                this.$nextTick(() => {
                    styleSelect(this.select);
                    if (typeof window.dropdownDirection === 'function') {
                        const select = this.$el.querySelector('.ss-selected-option');
                        if (select) {
                            select.addEventListener('click', window.dropdownDirection);
                        }
                    }
                });
            }
        }

        // TODO: next time someone sees this, investigate why and if this dark magic is needed, I think double equal (==) is enough
        private isEqual(value1: undefined|null|string|number, value2: undefined|null|string|number) {
            if (
                typeof value1 !== 'undefined'
                && value1 !== null
                && typeof +value1 === 'number'
                && !isNaN(+value1)
                && typeof value2 !== 'undefined'
                && value2 !== null
            ) {
              return parseInt(value1.toString()) === parseInt(value2!.toString());
            }

            return value1 === value2;
        }

        mounted() {
            this.onReadonlyChanged();
        }
    }
